import { LeadBanner } from "api"
import { useIsDesktop } from "common/MediaQueries"
import GenericButton from "components/GenericButton/GenericButton"
import Image from "next/image"
import Link from "next/link"
import styled from "styled-components"

const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
`

const StyledBannerContainer = styled.div`
  max-width: 1280px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 40px 16px 0 16px;

  ${(p) => p.theme.breakpoints.up("md")} {
    flex-direction: row;
    justify-content: space-between;
    margin: 128px 0 0 0;
    gap: 60px;
    align-items: center;
    width: 1160px;
  }

  ${(p) => p.theme.breakpoints.up("xl")} {
    gap: 120px;
  }
`

const StyledBannerImage = styled(Image)`
  object-fit: cover;
  border-radius: 8px;
`

const StyledBannerCard = styled.div`
  ${(p) => p.theme.breakpoints.up("md")} {
    width: 500px;
  }
`

const StyledTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 16px 0;

  ${(p) => p.theme.breakpoints.up("md")} {
    margin-bottom: 40px;
  }
`

const StyledBannerTitle = styled.h2`
  color: var(--Black, var(--Primary-Black, #000));
  text-align: right;
  font-family: NarkisBlock;
  font-size: 32px;
  font-style: normal;
  font-weight: bold;
  line-height: normal;

  margin: 0;
`

const StyledBannerBody = styled.p`
  color: var(--Black, var(--Primary-Black, #000));
  text-align: right;
  font-family: NarkisBlock;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  margin: 0;
`

const StyledBannerBtn = styled(GenericButton)`
  padding: 8px 16px;
`

type CompaniesBannerProps = {
  companiesBanner: LeadBanner
}

const CompaniesBannerHome = ({ companiesBanner }: CompaniesBannerProps) => {
  const isDesktop = useIsDesktop()
  return (
    <StyledContainer>
      <StyledBannerContainer>
        <StyledBannerImage
          src={isDesktop ? "/girl-with-chips.jpg" : "/girl-with-chips.jpg"}
          width={isDesktop ? "534px" : "328px"}
          height={isDesktop ? "335px" : "206px"}
          alt="hero image"
        />
        <StyledBannerCard>
          <StyledTextContainer>
            <StyledBannerTitle>{companiesBanner.bannerTitle}</StyledBannerTitle>
            <StyledBannerBody>
              {companiesBanner.bannerSubTitle}
            </StyledBannerBody>
          </StyledTextContainer>
          <Link href="/companies">
            <StyledBannerBtn btnType="filled" width={153} mobileWidth={153}>
              {companiesBanner.bannerCTAText}
            </StyledBannerBtn>
          </Link>
        </StyledBannerCard>
      </StyledBannerContainer>
    </StyledContainer>
  )
}

export default CompaniesBannerHome
